import {
  GET_VENDOR_EVENT_PROFILE,
  GET_VENDOR_EVENT_PROFILE_FAIL,
  GET_VENDOR_EVENT_PROFILE_SUCCESS,
  GET_VENDOR_EVENT,
  GET_VENDOR_EVENT_FAIL,
  GET_VENDOR_EVENT_SUCCESS,
  ADD_NEW_VENDOR_EVENT,
  ADD_VENDOR_EVENT_SUCCESS,
  ADD_VENDOR_EVENT_FAIL,
  UPDATE_VENDOR_EVENT,
  UPDATE_VENDOR_EVENT_SUCCESS,
  UPDATE_VENDOR_EVENT_FAIL,
  DELETE_VENDOR_EVENT,
  DELETE_VENDOR_EVENT_SUCCESS,
  DELETE_VENDOR_EVENT_FAIL,
} from "./actionTypes"

export const getVendor_event = ({id,offset='',page_size=''}) => ({
  type: GET_VENDOR_EVENT,
  payload:{id,offset,page_size}
})

export const getVendor_eventSuccess = Vendor_event => ({
  type: GET_VENDOR_EVENT_SUCCESS,
  payload: Vendor_event,
})

export const getVendor_eventFail = error => ({
  type: GET_VENDOR_EVENT_FAIL,
  payload: error,
})

export const addNewVendor_event = (user,history) => ({
  type: ADD_NEW_VENDOR_EVENT,
  payload: {user,history},
})

export const addVendor_eventSuccess = user => ({
  type: ADD_VENDOR_EVENT_SUCCESS,
  payload: user,
})  

export const addVendor_eventFail = error => ({
  type: ADD_VENDOR_EVENT_FAIL,
  payload: error,
})

export const updateVendor_event = (user, history) => ({
  type: UPDATE_VENDOR_EVENT,
  payload: { user, history },
})

export const updateVendor_eventSuccess = user => ({
  type: UPDATE_VENDOR_EVENT_SUCCESS,
  payload: user,
})

export const updateVendor_eventFail = error => ({
  type: UPDATE_VENDOR_EVENT_FAIL,
  payload: error,
})

export const deleteVendor_event = user => ({
  type: DELETE_VENDOR_EVENT,
  payload: user,
})

export const deleteVendor_eventSuccess = user => ({
  type: DELETE_VENDOR_EVENT_SUCCESS,
  payload: user,
})

export const deleteVendor_eventFail = error => ({
  type: DELETE_VENDOR_EVENT_FAIL,
  payload: error,
})

export const getVendor_eventProfile = () => ({
  type: GET_VENDOR_EVENT_PROFILE,
})

export const getVendor_eventProfileSuccess = userProfile => ({
  type: GET_VENDOR_EVENT_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getVendor_eventProfileFail = error => ({
  type: GET_VENDOR_EVENT_PROFILE_FAIL,
  payload: error,
})
